import React from 'react';
import { PRICE } from './salesData';
interface PriceBlockProps {
  className?: string;
  size?: 'md' | 'lg';
}

/**
 * Único bloque de precio de la landing. Precio anterior tachado + precio
 * vigente en pesos argentinos, con la jerarquía puesta en el vigente.
 * Composición horizontal para que la card de compra se mantenga compacta.
 */
export function PriceBlock({
  className = '',
  size = 'md'
}: PriceBlockProps) {
  const current = size === 'lg' ? 'text-[3.4rem] sm:text-[4.2rem]' : 'text-[2.4rem] sm:text-[2.9rem]';
  const unit = size === 'lg' ? 'text-base sm:text-xl' : 'text-sm';
  return <div className={`flex flex-col items-center gap-3 sm:flex-row sm:items-center sm:justify-center sm:gap-6 ${className}`} data-id="element-290" data-mp="1tws14pfg3owq">
      <div data-id="element-291" data-mp="1p3ywe1jz8gkn">
        <p className="flex items-center justify-center gap-2 sm:justify-start" data-id="element-292" data-mp="1p474lg55mxpi">
          <span className="font-sans text-[0.62rem] font-bold uppercase tracking-editorial text-charcoal-mid" data-id="element-293" data-mp="11ecw1arvbvb2">
            Antes
          </span>
          <span className="font-display text-[1.15rem] leading-none tabular-nums text-charcoal-mid line-through decoration-[#F47A2A] decoration-2 sm:text-[1.35rem]" data-id="element-294" data-mp="1rzrni02k9138">
            {PRICE.currency}
            {PRICE.previous}
          </span>
        </p>

        <div className="mt-1.5 flex items-start justify-center gap-2 sm:justify-start" data-id="element-295" data-mp="21q31kffykqnu">
          <span className={`mt-1.5 font-display leading-none text-caramel ${unit}`} data-id="element-296" data-mp="26ncn3k088i6e">
            {PRICE.currency}
          </span>
          <p className={`font-display leading-[0.86] tabular-nums text-charcoal ${current}`} data-id="element-297" data-mp="19306jxahqy2c">
            {PRICE.current}
          </p>
          <span className="mt-2 font-sans text-[0.68rem] font-bold uppercase tracking-[0.12em] text-caramel sm:text-[0.8rem]" data-id="element-298" data-mp="1iyjzcatrdgmv">
            {PRICE.unit}
          </span>
        </div>
      </div>

      <div className="text-center sm:max-w-[13rem] sm:border-l sm:border-warm sm:pl-6 sm:text-left" data-id="element-299" data-mp="2ueibink8gisb">
        <p className="font-sans text-[0.62rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-300" data-mp="2yfk6gs74a8oh">
          Hoy · Precio de lanzamiento
        </p>
        <p className="mt-1 font-sans text-[0.8rem] font-semibold leading-snug text-charcoal" data-id="element-301" data-mp="z98y8k89c6nt">
          {PRICE.note}
        </p>
        <p className="mt-1 font-sans text-[0.72rem] leading-snug text-charcoal-mid" data-id="element-302" data-mp="18brx6t8x9z4s">{PRICE.fx}</p>
      </div>
    </div>;
}